<div class="header-content-footer-root">
  <app-user-header *ngIf="isMobile" [imgSource]="authenticatedUserService.representative?.picture">
    {{ headerTitle }}
  </app-user-header>
  <app-top-header-desktop *ngIf="!isMobile"
                          [representative]="authenticatedUserService.representative"
                          [business]="topHeaderService.business"
                          [pointSummary]="topHeaderService.pointSummary"
                          [businessSummary]="topHeaderService.businessSummary"
                          [loading]="loading"></app-top-header-desktop>
  <div class="content">
    <ng-content select="[content]"></ng-content>
  </div>
  <app-navigation-bar class="footer" *ngIf="isMobile"></app-navigation-bar>
</div>
